import { api } from 'shared';
import { z } from 'zod';

const SweetShopArticlesByUidsResponseSchema = z.object({
    data: z.array(
        z.object({
            documentId: z.string(),
            slug: z.string(),
            name: z.string(),
            images: z.array(
                z.object({
                    url: z.string(),
                }),
            ).optional().nullable(),
            price: z.number().optional().nullable(),
            currency: z.object({
                name: z.string(),
                abbreviation: z.string(),
            }).optional().nullable(),
        }),
    ),
});

export const fetchSweetShopArticlesByUids = async (uids: string[]) => (
    api.get<z.infer<typeof SweetShopArticlesByUidsResponseSchema>>(
        '/sweet-shop-articles',
        {
            filters: {
                slug: {
                    $in: uids,
                },
            },
            populate: {
                images: {
                    fields: '*',
                },
                currency: {
                    fields: '*',
                },
            },
        },
        SweetShopArticlesByUidsResponseSchema,
    )
);
